 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480":"app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873":"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e":"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e","app-actions~app-registration~config-account~config-bot":"app-actions~app-registration~config-account~config-bot","app-actions":"app-actions","app-registration":"app-registration","config-account":"config-account","app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe":"app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe","app-elaborators":"app-elaborators","app-groups":"app-groups","app-information":"app-information","app-members":"app-members","app-messages":"app-messages","appview":"appview","auth":"auth","config":"config","default":"default","pricing":"pricing","config-users":"config-users","home":"home","config-bot":"config-bot","auth-login":"auth-login","auth-reset":"auth-reset","auth-signup":"auth-signup","auth-verify":"auth-verify","app-dashboard":"app-dashboard","features":"features"}[chunkId]||chunkId) + "." + {"404":"10a7abba","app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480":"9f77a9f2","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873":"b822cb99","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e":"164e362f","app-actions~app-registration~config-account~config-bot":"f1105987","app-actions":"32066927","app-registration":"2f28b6b8","config-account":"2e2ecc84","app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe":"57255281","app-elaborators":"4607f8de","app-groups":"dc953aca","app-information":"ee0d616b","app-members":"4ecc7a58","app-messages":"1c1a8605","appview":"5013f4cf","auth":"5061b877","config":"d45dfb5a","default":"d23063cd","pricing":"669bac0c","config-users":"7623a602","home":"c3b70a8c","config-bot":"d233d3cc","auth-login":"e9e9fc2e","auth-reset":"bf7bfbcb","auth-signup":"973f0c52","auth-verify":"da238404","app-dashboard":"19c95339","features":"f8c098ba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480":1,"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873":1,"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e":1,"app-actions~app-registration~config-account~config-bot":1,"app-actions":1,"app-registration":1,"config-account":1,"app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe":1,"app-elaborators":1,"app-groups":1,"app-information":1,"app-members":1,"app-messages":1,"appview":1,"auth":1,"config":1,"default":1,"pricing":1,"config-users":1,"home":1,"config-bot":1,"auth-login":1,"auth-reset":1,"auth-signup":1,"auth-verify":1,"app-dashboard":1,"features":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480":"app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873":"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e":"app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e","app-actions~app-registration~config-account~config-bot":"app-actions~app-registration~config-account~config-bot","app-actions":"app-actions","app-registration":"app-registration","config-account":"config-account","app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe":"app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe","app-elaborators":"app-elaborators","app-groups":"app-groups","app-information":"app-information","app-members":"app-members","app-messages":"app-messages","appview":"appview","auth":"auth","config":"config","default":"default","pricing":"pricing","config-users":"config-users","home":"home","config-bot":"config-bot","auth-login":"auth-login","auth-reset":"auth-reset","auth-signup":"auth-signup","auth-verify":"auth-verify","app-dashboard":"app-dashboard","features":"features"}[chunkId]||chunkId) + "." + {"404":"9196ef73","app-actions~app-dashboard~app-elaborators~app-groups~app-information~app-members~app-messages~app-re~26f88480":"38498376","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~1e0a6873":"20c3a3dd","app-actions~app-elaborators~app-groups~app-information~app-members~app-messages~app-registration~app~96d1728e":"5b5a95c1","app-actions~app-registration~config-account~config-bot":"48ec34b7","app-actions":"89924bf3","app-registration":"e9fed667","config-account":"da40c292","app-elaborators~app-groups~app-information~app-members~app-messages~appview~auth~auth-login~auth-res~7c186bbe":"8e4b163a","app-elaborators":"6d4fa3ad","app-groups":"a512bafb","app-information":"514b8a94","app-members":"1d133e1c","app-messages":"9b0fcf71","appview":"20faa2b9","auth":"a2ed1401","config":"98c52e05","default":"3c559e14","pricing":"ddf3c267","config-users":"6a44ac2b","home":"d64f989e","config-bot":"d5ecfe08","auth-login":"4faa9709","auth-reset":"4faa9709","auth-signup":"ed26fddc","auth-verify":"4faa9709","app-dashboard":"89189769","features":"b024b632"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
